import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppRoutes } from '@helpers/app-routes';
import { AuthService } from '@services/auth.service';
import { TerminalService } from '@services/terminal.service';

export const ensureTenantMatchGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const terminalService = inject(TerminalService);
  const router = inject(Router);

  const user = authService.getCurrentUser();
  const terminal = terminalService.currentTerminal();

  if (user && terminal && user.customer !== undefined && user.customer !== terminal.customer_id) {
    terminalService.markTenantMismatch();
    return router.createUrlTree([AppRoutes.login]);
  }

  terminalService.clearTenantMismatch();
  return true;
};
